(ns motorsaif.app
  (:require
    [motorsaif.web.core :as core]))

;; (extend-protocol IPrintWithWriter
;;   js/Symbol
;;   (-pr-writer [sym writer _]
;;     (-write writer (str "\"" (.toString sym) "\""))))

(core/init! :prod)
